import React, { useState } from 'react';
import Header from '../../components/common/header';
import { AiFillDownSquare } from "react-icons/ai";

const FAQItem = ({ question, answer, isDefaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(isDefaultOpen);

    return (
        <div className="singleFaqBox">
            <div className="faqTopLine" onClick={() => setIsOpen(!isOpen)}>
                <p className="faqQuestion">{question}</p>
                <AiFillDownSquare className={`faqArrow ${isOpen ? "rotate" : ""}`} />
            </div>
            <div className={`faqAnswer ${isOpen ? "show" : "hide"}`} 
                 dangerouslySetInnerHTML={{ __html: answer }} />
        </div>
    );
};

const Faq = () => {
    return (
        <div className='full_page_inner'>
            <Header />
            <div className='dashboard_container'>
                <div className="faq_container">
                    <div className='innerData'>
                        <p className='faqMainTitle'>FAQs </p>

                        {/* Your Account Section */}
                        <p className="faqSmallTitle">Getting Started</p>
                        <div className="outerSingleBox">
                        <div className='innerBoxes'>
                            <FAQItem 
                                question="How do I sign up and subscribe to Dreamer Diaries?" 
                                answer="<a href='/my-profile'>Click here</a> to choose your subscription. After subscribing, you’ll receive an email with
links to download the app on iOS or Android. Once downloaded, create a new account
using the same email as your subscription. Log in, and you’re ready to go!."
                                isDefaultOpen={false}
                            />
                        </div>
                        </div>

                        {/* Projects Section */}
                        <p className="faqSmallTitle">Projects</p>
                        <div className="outerSingleBox">
                        <div className='innerBoxes'>
                            <FAQItem 
                                question="How do I create my first project?" 
                                answer="Click the <strong>Projects</strong> link in the top main menu, then the <strong>New Project+</strong> button. Fill in
details like the design name, artist, brand, canvas size, diamond info, price, start date,
and at least one image. Add tags or notes to help organize and remember each project."
                            />
                            <FAQItem 
                                question="How do I use the barcode scanner?" 
                                answer="Click the <strong>Projects</strong> link in the top main menu, then the <strong>New Project+</strong> button. Find
and click the <strong>QR</strong> icon (near the middle of the page). Grant camera access and scan the
barcode on your Dreamer kit box. Details will auto-fill. On desktop, try moving the
barcode closer if it doesn’t scan. You can also enter the barcode manually below."
                            />
                            <FAQItem 
                                question="How do I start or stop the timer?" 
                                answer="New projects go to your <strong>“Not Started”</strong> section. Start the timer from the collection
view or project page using the play icon — the project will move to
<strong>“Work-in-Progress.”</strong> Pause the timer anytime from either view."
                            />
                            <FAQItem 
                                question="Can I edit the timer?" 
                                answer="Yes, for in-progress projects. Open the project, click the pencil icon next to <strong>“Logged
time,“</strong> make your changes, and save. Timers for completed projects cannot be edited."
                            />
                            <FAQItem 
                                question="How do I edit a project?" 
                                answer="Open the project and click the <strong>3-dot icon</strong> (top right). Select <strong>“Edit Project”</strong> and
make your changes."
                            />
                            </div>
                            <div className='innerBoxes'>
                            <FAQItem 
                                question="How do I mark a project as complete?" 
                                answer=" From the project page, click <strong>“Mark as Complete”</strong> (bottom left). Confirm it’s done,
and it will move to your <strong>“Completed”</strong> section.
</br>
⚠️ <strong>Note:</strong> This action is permanent"
                            />
                            <FAQItem 
                                question="How can I search for my projects?" 
                                answer="Use the <strong>search bar</strong> at the top of the Projects tab. Type keywords like design name,
artist, or brand to filter results."
                            />
                            <FAQItem 
                                question="How can I sort my projects?" 
                                answer="Use the <strong>“Sort By”</strong> filter in each collection or search results page to organize your
projects."
                            />
                            <FAQItem 
                                question="What if I forget to set start/end dates?" 
                                answer="No worries! The app auto-sets your <strong>start date</strong> when you begin the timer, and the
<strong>end date</strong> when you complete the project."
                            />
                            <FAQItem 
                                question="How do I delete a project?" 
                                answer="Open the project, click the <strong>3-dot icon</strong> (top right), select <strong>“Delete Project,”</strong> and
confirm.
<strong>
</br>
⚠️ Note:</strong> Deleted projects cannot be recovered."
                            />
                        </div>
                    </div>

                         {/* Leaderboard Section */}
                         <p className="faqSmallTitle">Leaderboard</p>
                        <div className="outerSingleBox">
                        <div className='innerBoxes'>
                            <FAQItem 
                                question="How do I opt into the Leaderboard?" 
                                answer="Three steps:
                                <ol>
                                <li>Opt in at the bottom of the <strong>“New Project”</strong> screen.</li>
                                <li>Upload a <strong>Start Canvas</strong> photo showing the canvas and today’s date on paper.</li>
                                <li>When done, upload a <strong>Finish Canvas</strong> photo with the finished work and date.</li>
                                </ol>
                                Once uploaded, you’ll get a confirmation popup. Allow 1–2 business days for manual
review and for your points to appear."
                            />
                            <FAQItem 
                                question=" How does the Leaderboard work?" 
                                answer="It adds fun competition! Complete more projects to earn points and win prizes.
                                <ul>
                                <li><strong>Current Leaderboard</strong> resets every 2 months and ranks projects based on their
start and end dates.</li>
                                <li><strong>All-Time Leaderboard</strong> tracks your lifetime points without resetting.
</li>
                                </ul>
                                "
                            />
                            <FAQItem 
                                question="How are points calculated?" 
                                answer="Canvas width × height = total points.
                                </br>
                                Example:
                                 <ul>
                                <li>80x60cm = 4,800 points</li>
                                <li>40x50cm = 2,000 points</li>
                                </ul>
                                <strong>Total = 6,800 points</strong>
                                "
                            />
                            </div>
                            <div className='innerBoxes'>
                            <FAQItem 
                                question="How do you prevent cheating?" 
                                answer="Each project must have a <strong>Start</strong> and <strong>Finish</strong> photo with handwritten dates. Our team
manually verifies both before awarding points."
                            />
                            <FAQItem 
                                question="How do I know if my project was submitted?" 
                                answer="After uploading the <strong>Finish Canvas</strong> photo, a popup will confirm submission. You'll get
an email within 1–2 business days once approved."
                            />
                            <FAQItem 
                                question="Who is eligible for prizes?" 
                                answer=" Any <strong>premium user</strong> who submits verified projects can win! Prize pool (every 2
                                months):
                                <ul>
                                <li>1st: $200 gift card</li>
                                <li>2nd: $100 gift card</li>
                                <li>3rd: $50 gift card</li>
                                <li>4th–10th: $25 gift card</li>
                                 </ul>
                                        "
                            />
                          
                        </div>
                        </div>
                          {/* Shuffle Section */}
                          <p className="faqSmallTitle">Shuffle</p>
                        <div className="outerSingleBox">
                        <div className='innerBoxes'>
                        <FAQItem 
                                question="How does Shuffle work" 
                                answer="Not sure what to paint next? Tap <strong>Shuffle</strong> to randomly select one of your <strong>“Not
Started”</strong> projects"
                            />
                            <FAQItem 
                                question="Why aren’t all projects showing in Shuffle?" 
                                answer="Only <strong>“Not Started”</strong> projects appear. WIP and completed projects are excluded"
                            />
                            </div>
                            <div className='innerBoxes'>
                        <FAQItem 
                                question="Do I have to pick the suggested project?" 
                                answer="Nope! Shuffle gives a fun suggestion, but you’re free to spin again or pick a different
project."
                            />
                            <FAQItem 
                                question="How often can I use Shuffle?" 
                                answer="As often as you like — no limits!"
                            />
                            </div>
                        </div>

                
                          <p className="faqSmallTitle">Account Settings</p>
                        <div className="outerSingleBox">
                        <div className='innerBoxes'>
                      
                            <FAQItem 
                                question="How do I change my profile picture?" 
                                answer="Click the <strong>profile dropdown icon</strong> in the top right corner → <strong>My Profile</strong> → tap the
avatar on the left to change it.</br>
✅ Don’t forget to click the <strong>Update</strong> button to save your changes."
                            />
                             <FAQItem 
                                question="How do I change my name or email?" 
                                answer="Click the <strong>profile dropdown icon</strong> → <strong>My Profile</strong> → under the <strong>Personal Information</strong>
tab, change your name or email.</br>
✅ Be sure to click <strong>Update</strong> to save changes."
                            />
                            </div>
                            <div className='innerBoxes'>
                        <FAQItem 
                                question="How do I change my password?" 
                                answer="Click the <strong>profile dropdown icon</strong> → <strong>My Profile</strong> → under the <strong>Settings</strong> tab, click
<strong>Change Password.</strong>"
                            />
                            <FAQItem 
                                question="How do I cancel my subscription?" 
                                answer="Click the <strong>profile dropdown icon</strong> → <strong>My Profile</strong> → find the <strong>“Cancel Subscription”</strong>
link in the bottom left corner."
                            />
                             <FAQItem 
                                question="How do I delete my account?" 
                                answer="Click the <strong>profile dropdown icon</strong> → <strong>My Profile</strong> → under the <strong>Settings</strong> tab, click
<strong>Delete Account</strong>.</br>
⚠️ Warning: This action is permanent — all projects will be lost."
                            />
                            </div>
                        </div>
                           {/* Shuffle Section */}
                           <p className="faqSmallTitle">Support & Feedback</p>
                        <div className="outerSingleBox">
                        <div className='innerBoxes'>
                        <FAQItem 
                                question="How do I contact support?" 
                                answer="Click the <strong>profile dropdown icon</strong> → <strong>My Profile</strong> → under the <strong>Settings tab</strong>, click
                                   <strong> Support.</strong>"
                            />
                            </div>
                       
                            </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faq;
